import React, { useCallback, useContext } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../head-container';
import { getImageFromS3 } from '../../../../imageService';
import useTelegramLink from '../../../../hooks/useTelegramLink';
import { DataLayerEventContext } from '../../../../contexts/dataLayerEventContext';

const ResultComponent = ({ setScreenNumber, isSuccess = true }) => {
  const { telegramLink } = useTelegramLink();
  const { sendEvent } = useContext(DataLayerEventContext);

  const onTelegramClick = useCallback(() => {
    sendEvent('telegram');
    window.open(telegramLink, '_blank');
  }, [sendEvent, telegramLink]);

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <HeadContainer setScreenNumber={setScreenNumber} />
        <div className={styles.content}>
          <p className={styles.title}>
            {isSuccess ? 'Дякуємо за відгук!' : 'Дякуємо!'}
          </p>
          <p className={styles.subtitle}>
            {isSuccess
              ? 'Твій мобільний рахунок буде поповнено найближчим часом.'
              : 'Для отримання поповнення приходь наступного місяця!'}
          </p>
          <p className={styles.telegramBanner}>
            Долучайся у Телеграм, щоб бути на зв&#39;язку зі своїм брендом.
          </p>
          <div className={styles.telegramIcon} onClick={onTelegramClick}>
            <img
              src={getImageFromS3('images/lm-double-splash/telegram.png')}
              alt="telegram-icon"
            />
          </div>
          <button
            className={styles.whiteButton}
            onClick={() => setScreenNumber(1)}
          >
            Повернутися до меню
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultComponent;
